import styled from "@emotion/styled";
import {
  Avatar,
  Box,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import MediaAssets from "assets";
import {
  ButtonComponent,
  FormFieldContainer,
  SwitchComponent,
  TextFieldComponent,
} from "components/ui-elements";
import { FieldArray, getIn, useFormikContext } from "formik";
import React, { Fragment, useState } from "react";
import QuillEditor from "components/quill-editor/QuillEditor";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useSelector } from "react-redux";
import { IInitinalValueProjectContent } from "../UpCommingInitialValues";
import TourismAroundMedia from "../../opportunity-doc/TourismAroundMedia";

export const FormFieldContainerWrapper = styled(FormFieldContainer)``;

function TourismAround(props:any) {
    const { isViewMode } = props;

  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue,
    setFieldError,
    handleBlur,
    errors,
    touched,
  } = useFormikContext<IInitinalValueProjectContent>();

  const [currentlyOpenedIndex, setCurrentlyOpenedIndex] = useState(999);
  // const isViewMode = useSelector(
  //   (state: any) => state?.projectContentManagement?.isViewMode
  // );

  const handleTourismAroundMedia = (imageIndex: number) => {
    setCurrentlyOpenedIndex(imageIndex);
  };

  const handleTextEditor = (
    name: string,
    newValue: string,
    options: any,
    { setFieldValue, setFieldError }: any
  ) => {
    // if (options?.isError) {
    //   setFieldError(name, "Maximum character exceed");
    // } else {
    setFieldValue(name, newValue);
    // }
  };

  return (
    <div>
      <Stack justifyContent={"flex-start"} padding={2} spacing={1}>
        <Typography>Tourism Around</Typography>

        <FormControlLabel
          className="switch-form-label"
          name={"opportunityDoc.isTourismAroundActive"}
          checked={values?.opportunityDoc?.isTourismAroundActive}
          onChange={handleChange}
          control={<SwitchComponent />}
          label=""
          labelPlacement="start"
          disabled={isViewMode}
        />

        <IconButton>
          <Tooltip title={"Tourism Around"} placement="top">
            <Avatar
              style={{
                width: "0.9rem",
                height: "0.9rem",
                cursor: "pointer",
              }}
              src={MediaAssets.ic_info}
              variant="rounded"
            />
          </Tooltip>
        </IconButton>
        <Typography>Tourism Around for Website</Typography>

        <FormControlLabel
          className="switch-form-label"
          name={"opportunityDoc.isTourismAroundActiveForWeb"}
          checked={values?.opportunityDoc?.isTourismAroundActiveForWeb}
          onChange={handleChange}
          control={<SwitchComponent />}
          label=""
          labelPlacement="start"
          disabled={isViewMode}
        />

        <IconButton>
          <Tooltip title={"Tourism Around"} placement="top">
            <Avatar
              style={{
                width: "0.9rem",
                height: "0.9rem",
                cursor: "pointer",
              }}
              src={MediaAssets.ic_info}
              variant="rounded"
            />
          </Tooltip>
        </IconButton>
      </Stack>
      <Grid
        item
        xs={3}
        sm={3}
        md={3}
        lg={3}
        xl={3}
        p={3}
        sx={{
          padding: 0,
        }}
      >
        <TextFieldComponent
          required
          type="text"
          placeholder="Enter"
          label="Section Heading"
          name={`opportunityDoc.tourismAround.heading`}
          value={values?.opportunityDoc?.tourismAround?.heading}
          onChange={handleChange}
          inputProps={{ maxLength: 40 }}
          onBlur={handleBlur}
          fieldhelpertext={
            getIn(touched, `opportunityDoc.tourismAround.heading`) &&
            getIn(errors, `opportunityDoc.tourismAround.heading`)
          }
          error={Boolean(
            getIn(errors, `opportunityDoc.tourismAround.heading`) &&
              getIn(touched, `opportunityDoc.tourismAround.heading`)
          )}
          disabled={isViewMode}
        />
      </Grid>
      <FieldArray
        name="opportunityDoc.tourismAround.stories"
        render={(arrayHelpers) => (
          <div>
            {values?.opportunityDoc?.tourismAround?.stories?.length > 0 &&
              values?.opportunityDoc?.tourismAround?.stories?.map(
                (element: any, index: number) => {
                  return (
                    <Fragment>
                      <FormFieldContainerWrapper>
                        <Stack justifyContent={"flex-end"}>
                          {values?.opportunityDoc?.tourismAround?.stories
                            ?.length > 1 && (
                            <IconButton
                              disabled={isViewMode}
                              aria-label="delete"
                              data-testid="button-delete"
                              onClick={() => {
                                arrayHelpers.remove(index);
                              }}
                            >
                              <DeleteOutlineOutlinedIcon className="table-action-icon delete-icon" />
                            </IconButton>
                          )}
                        </Stack>
                        <Grid
                          container
                          alignItems={"center"}
                          justifyContent={"space-between"}
                        >
                          <Grid item xs={7} sm={7} md={7} lg={7} xl={8}>
                            <Box mr={"20rem"}>
                              <TextFieldComponent
                                required
                                type="text"
                                placeholder="Enter"
                                label="Image Title"
                                name={`opportunityDoc.tourismAround.stories.${index}.title`}
                                value={
                                  values?.opportunityDoc?.tourismAround
                                    ?.stories[index]?.title
                                }
                                onChange={handleChange}
                                inputProps={{ maxLength: 30 }}
                                onBlur={handleBlur}
                                fieldhelpertext={
                                  getIn(
                                    touched,
                                    `opportunityDoc.tourismAround.stories.${index}.title`
                                  ) &&
                                  getIn(
                                    errors,
                                    `opportunityDoc.tourismAround.stories.${index}.title`
                                  )
                                }
                                error={Boolean(
                                  getIn(
                                    errors,
                                    `opportunityDoc.tourismAround.stories.${index}.title`
                                  ) &&
                                    getIn(
                                      touched,
                                      `opportunityDoc.tourismAround.stories.${index}.title`
                                    )
                                )}
                                disabled={isViewMode}
                              />
                            </Box>

                            <Typography>Description</Typography>
                            <QuillEditor
                              placeholder="Enter description"
                              //   className={styles["QuillEditor"]}
                              name={`opportunityDoc.tourismAround.stories.${index}.description`}
                              value={
                                values?.opportunityDoc?.tourismAround?.stories[
                                  index
                                ]?.description
                              }
                              onChange={(
                                name: string,
                                newValue: string,
                                options: any
                              ) =>
                                handleTextEditor(name, newValue, options, {
                                  setFieldValue,
                                  setFieldError,
                                })
                              }
                              // style={{ height: "12rem" }}
                              inputProps={{ maxLength: 240 }}
                              style={{ height: "126px" }}
                              disabled={isViewMode}
                            />
                          </Grid>
                          <Grid item xs={3} sm={3} md={3} lg={4} xl={3}>
                            <TourismAroundMedia
                              index={index}
                              isViewModeProp={isViewMode}
                              currentlyOpenedIndex={currentlyOpenedIndex}
                              handleTourismAroundMedia={
                                handleTourismAroundMedia
                              }
                            />
                          </Grid>
                        </Grid>
                      </FormFieldContainerWrapper>
                      <Grid item xs={3} sm={3} md={3} lg={3} xl={3} ml={2}>
                        {values?.opportunityDoc?.tourismAround?.stories
                          ?.length -
                          1 ===
                          index && (
                          <ButtonComponent
                            sx={{
                              textDecoration: "underline",
                              marginTop: "0.5rem",
                            }}
                            variant="text"
                            color="inherit"
                            onClick={() => {
                              arrayHelpers.push({
                                title: "",
                                description: "",
                                media: {
                                  name: "",
                                  key: "",
                                  value: {
                                    url: "",
                                    size: 0,
                                    width: 1024,
                                    height: 1024,
                                    mediaType: "image",
                                  },
                                },
                              });
                            }}
                            disabled={isViewMode}
                          >
                            + Add more Values
                          </ButtonComponent>
                        )}
                      </Grid>
                    </Fragment>
                  );
                }
              )}
          </div>
        )}
      />
      <Divider sx={{ mt: "0.5rem" }} />
    </div>
  );
}

export default TourismAround;
